import { IAnalyticsEvent, ISetCustomerIdentity } from 'state/analytics/types';

import { IAnalyticsAdapter } from './types';

export class AnalyticsProvider {
  private providers: IAnalyticsAdapter[] = [];
  private isInitialized: boolean = false;

  public initialize = (providers: IAnalyticsAdapter[]): void => {
    if (!this.isInitialized) {
      this.providers = providers;
      this.isInitialized = true;
    }
  };

  public logEvent = (event: IAnalyticsEvent): void => {
    this.providers.forEach((provider: IAnalyticsAdapter) => {
      provider.logEvent(event);
    });
  };

  public setCustomerIdentity = (customerData: ISetCustomerIdentity): void => {
    this.providers.forEach((provider: IAnalyticsAdapter) => {
      provider.setCustomerIdentity(customerData);
    });
  };

  public logOutCustomer = (): void => {
    this.providers.forEach((provider: IAnalyticsAdapter) => {
      provider.logOutCustomer();
    });
  };
}

const analyticsProvider = new AnalyticsProvider();
export default analyticsProvider;
